import {makeObservable} from 'mobx';

import type {Nullable} from '../../../utils/utility-types';
import type {CouponModel} from '../Coupon/Coupon.model';
import type {DateTimeModel} from '../Date/DateTime.model';
import type {SubtenantModel} from '../Subtenant/Subtenant.model';
import type {UserModel} from '../User/User.model';

import {BaseModel} from '../Base/Base.model';

const ModelName = 'WaitlistItemModel';

export class WaitlistItemModel extends BaseModel {
  coupon: Nullable<CouponModel>;
  createdDate: DateTimeModel;
  email: string;
  invitedDate: Nullable<DateTimeModel>;
  joinedDate: Nullable<DateTimeModel>;
  position: number;
  status: WaitlistItemModel.Status;
  subtenant: SubtenantModel;
  updateDate: DateTimeModel;
  user: UserModel;

  constructor(props: WaitlistItemModel.Props) {
    super(props);
    Object.assign(this, props);

    this.status = this.computeStatus();

    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<
        WaitlistItemModel,
        WaitlistItemModel.Props
      >(props),
    );
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }

  private computeStatus(): WaitlistItemModel.Status {
    switch (true) {
      case Boolean(this.joinedDate):
        return WaitlistItemModel.Status.JOINED;
      case Boolean(this.invitedDate):
        return WaitlistItemModel.Status.INVITED;
      default:
        return WaitlistItemModel.Status.WAITING;
    }
  }
}

export namespace WaitlistItemModel {
  export enum Status {
    INVITED = 'invited',
    JOINED = 'joined',
    WAITING = 'waiting',
  }

  export type Props = BaseModel.ModelToProps<WaitlistItemModel, 'status'>;
}
